import React, { useState } from "react";
import Accordion from "./Accordion";


const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(''); // 'success', 'error', or ''
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus('');
    setMessage('');

    // Replace this URL with your Google Apps Script Web App URL
    const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbwrfBAOUcKGS8HyYcsljaTA7NDEkblq4smriBVFfLhIGe8nlXxgKfGH4On_rdbgT4hmgA/exec';

    try {
      const response = await fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors', // Required for Google Apps Script
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      // Note: With 'no-cors', we can't read the response, so we assume success
      setStatus('success');
      setMessage('Thanks for signing up!');
      setEmail(''); // Clear the input
    } catch (error) {
      setStatus('error');
      setMessage('Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-[#222] text-[#ccc] py-8 md:py-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16 mb-16 text-left">
          <div className="footer-column">
            <h4 className="font-serif text-2xl mb-6 text-white">Newsletter</h4>
            <p className="text-base leading-[1.8] mb-4 text-[#ccc]">Sign up for the latest news, offers and styles</p>
            <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
              <input 
                type="email" 
                placeholder="Your email" 
                className="p-4 border border-[#555] bg-[#333] rounded text-white" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isSubmitting}
              />
              <button 
                type="submit" 
                className="bg-transparent border-2 border-primary text-primary py-4 px-8 shadow-none hover:bg-primary hover:text-white cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Subscribing...' : 'Subscribe'}
              </button>
              {status && (
                <p className={`text-sm ${status === 'success' ? 'text-green-400' : 'text-red-400'}`}>
                  {message}
                </p>
              )}
            </form>
          </div>
          <div className="footer-column">
            <Accordion title="Customer Service">
              <a href="/contact" className="text-[#ccc] no-underline transition-colors duration-300 hover:text-primary">Contact Us</a>
            </Accordion>
            <Accordion title="Visit Us">
              <p className="text-[#ccc] text-sm mb-2">Glasgow West End</p>
              <p className="text-[#ccc] text-sm mb-2">404 Byres Rd, Glasgow G12 8AS</p>
              <p className="text-[#ccc] text-sm mb-4">+44 141 237 0200</p>
              <p className="text-[#ccc] text-sm mb-2">Glasgow City</p>
              <p className="text-[#ccc] text-sm mb-2">34 Gordon St, Glasgow G1 3PU</p>
              <p className="text-[#ccc] text-sm mb-4">+44 141 249 9857</p>
              <p className="text-[#ccc] text-sm mb-2">St Andrews</p>
              <p className="text-[#ccc] text-sm mb-2">157a South St, St Andrews KY16 9UP</p>
              <p className="text-[#ccc] text-sm">+44 1334 208160</p>
            </Accordion>
            <Accordion title="About Us">
              <a href="/our-story" className="text-[#ccc] no-underline transition-colors duration-300 hover:text-primary">Our Story</a>
              <a href="/craftsmanship" className="text-[#ccc] no-underline transition-colors duration-300 hover:text-primary">Craftsmanship</a>
            </Accordion>
          </div>
          <div className="footer-column">
            <h4 className="font-serif text-2xl mb-6 text-white">Contact Us</h4>
            <p className="text-base leading-[1.8] mb-4 text-[#ccc]">
              Email:{" "}
              <a href="mailto:sales@jamesmackintosh.co.uk" className="text-[#ccc] no-underline transition-colors duration-300 hover:text-primary">
                sales@jamesmackintosh.co.uk
              </a>
            </p>
            <p className="text-base leading-[1.8] mb-4 text-[#ccc]">
              Phone: <a href="tel:+441334208160" className="text-[#ccc] no-underline transition-colors duration-300 hover:text-primary">+44 1334 208160</a>
            </p>
            <p className="text-base leading-[1.8] mb-4 text-[#ccc]">Address: 157a South St KY16 9UP</p>
            <div className="flex gap-4 mt-6 justify-start">
              <a
                href="https://www.facebook.com/mackintoshkilts"
                aria-label="Facebook"
                className="flex items-center justify-center w-[30px] h-[30px] text-[#ccc] transition-colors duration-300 hover:text-primary"
              >
                <svg className="w-full h-full fill-current" viewBox="0 0 20 20">
                  <path
                    fill="currentColor"
                    d="M18 10.049C18 5.603 14.419 2 10 2s-8 3.603-8 8.049C2 14.067 4.925 17.396 8.75 18v-5.624H6.719v-2.328h2.03V8.275c0-2.017 1.195-3.132 3.023-3.132.874 0 1.79.158 1.79.158v1.98h-1.009c-.994 0-1.303.621-1.303 1.258v1.51h2.219l-.355 2.326H11.25V18c3.825-.604 6.75-3.933 6.75-7.951"
                  ></path>
                </svg>
              </a>
              <a
                href="https://www.instagram.com/mackintoshkilts"
                aria-label="Instagram"
                className="flex items-center justify-center w-[30px] h-[30px] text-[#ccc] transition-colors duration-300 hover:text-primary"
              >
                <svg className="w-full h-full fill-current" viewBox="0 0 20 20">
                  <path
                    fill="currentColor"
                    fillRule="evenodd"
                    d="M13.23 3.492c-.84-.037-1.096-.046-3.23-.046-2.144 0-2.39.01-3.238.055-.776.027-1.195.164-1.487.273a2.4 2.4 0 0 0-.912.593 2.5 2.5 0 0 0-.602.922c-.11.282-.238.702-.274 1.486-.046.84-.046 1.095-.046 3.23s.01 2.39.046 3.229c.004.51.097 1.016.274 1.495.145.365.319.639.602.913.282.282.538.456.92.602.474.176.974.268 1.479.273.848.046 1.103.046 3.238.046s2.39-.01 3.23-.046c.784-.036 1.203-.164 1.486-.273.374-.146.648-.329.921-.602.283-.283.447-.548.602-.922.177-.476.27-.979.274-1.486.037-.84.046-1.095.046-3.23s-.01-2.39-.055-3.229c-.027-.784-.164-1.204-.274-1.495a2.4 2.4 0 0 0-.593-.913 2.6 2.6 0 0 0-.92-.602c-.284-.11-.703-.237-1.488-.273ZM6.697 2.05c.857-.036 1.131-.045 3.302-.045a63 63 0 0 1 3.302.045c.664.014 1.321.14 1.943.374a4 4 0 0 1 1.414.922c.41.397.728.88.93 1.414.23.622.354 1.279.365 1.942C18 7.56 18 7.824 18 10.005c0 2.17-.01 2.444-.046 3.292-.036.858-.173 1.442-.374 1.943-.2.53-.474.976-.92 1.423a3.9 3.9 0 0 1-1.415.922c-.51.191-1.095.337-1.943.374-.857.036-1.122.045-3.302.045-2.171 0-2.445-.009-3.302-.055-.849-.027-1.432-.164-1.943-.364a4.15 4.15 0 0 1-1.414-.922 4.1 4.1 0 0 1-.93-1.423c-.183-.51-.329-1.085-.365-1.943C2.009 12.45 2 12.167 2 10.004c0-2.161 0-2.435.055-3.302.027-.848.164-1.432.365-1.942a4.4 4.4 0 0 1 .92-1.414 4.2 4.2 0 0 1 1.415-.93c.51-.183 1.094-.33 1.943-.366Zm.427 4.806a4.105 4.105 0 1 1 5.805 5.805 4.105 4.105 0 0 1-5.805-5.805m1.882 5.371a2.668 2.668 0 1 0 2.042-4.93 2.668 2.668 0 0 0-2.042 4.93m5.922-5.942a.958.958 0 1 1-1.355-1.355.958.958 0 0 1 1.355 1.355"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </a>
              <a
                href="https://www.youtube.com/@Mackintoshkilts"
                aria-label="YouTube"
                className="flex items-center justify-center w-[30px] h-[30px] text-[#ccc] transition-colors duration-300 hover:text-primary"
              >
                <svg className="w-full h-full fill-current" viewBox="0 0 20 20">
                  <path
                    fill="currentColor"
                    d="M18.16 5.87c.34 1.309.34 4.08.34 4.08s0 2.771-.34 4.08a2.13 2.13 0 0 1-1.53 1.53c-1.309.34-6.63.34-6.63.34s-5.321 0-6.63-.34a2.13 2.13 0 0 1-1.53-1.53c-.34-1.309-.34-4.08-.34-4.08s0-2.771.34-4.08a2.17 2.17 0 0 1 1.53-1.53C4.679 4 10 4 10 4s5.321 0 6.63.34a2.17 2.17 0 0 1 1.53 1.53M8.3 12.5l4.42-2.55L8.3 7.4z"
                  ></path>
                </svg>
              </a>
              <a
                href="https://x.com/mackintoshkilts"
                aria-label="X (formerly Twitter)"
                className="flex items-center justify-center w-[30px] h-[30px] text-[#ccc] transition-colors duration-300 hover:text-primary"
              >
                <svg className="w-full h-full fill-current" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                  ></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="text-center pt-8 border-t border-[#444] text-sm text-[#888]">
          <p>&copy; {currentYear} Mackintosh's All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
